(function () {
  if (!window.RushAnalytics) {
    const blockedKeys = new Set([
      "billing_address",
      "customer",
      "customer_id",
      "email",
      "line_key",
      "name",
      "order_number",
      "phone",
      "query",
      "search_query",
      "shipping_address",
    ]);

    const sanitizeEventData = (eventData) => Object.fromEntries(Object.entries(eventData).flatMap(([key, value]) => {
      if (blockedKeys.has(key.toLocaleLowerCase()) || value === undefined || value === null) return [];
      if (typeof value === "number") return Number.isFinite(value) ? [[key, value]] : [];
      if (typeof value === "boolean") return [[key, value]];
      if (typeof value === "string") return [[key, value.slice(0, 200)]];
      return [];
    }));

    window.RushAnalytics = {
      publish(eventName, eventData = {}) {
        const name = `rush_controller:${eventName}`;
        const data = sanitizeEventData({
          page_path: window.location.pathname,
          device_type: window.matchMedia("(max-width: 768px)").matches ? "mobile" : "desktop",
          ...eventData,
        });
        const detail = { name, data };

        try {
          const publication = window.Shopify?.analytics?.publish?.(name, data);
          publication?.catch?.(() => {});
        } catch (error) {
          // Analytics must never interrupt the storefront experience.
        }

        document.dispatchEvent(new CustomEvent("rush:analytics", { detail }));
      },
    };
  }

  const publishRushEvent = window.RushAnalytics.publish;

  const heroExperiment = window.RushHeroExperiment;
  if (heroExperiment?.active) {
    document.querySelectorAll(`[data-hero-experiment="${heroExperiment.id}"]`).forEach((cta) => {
      const isVariant = heroExperiment.variant === "ready_to_ship";
      const label = isVariant ? cta.dataset.variantLabel : cta.dataset.controlLabel;
      const destination = isVariant ? cta.dataset.variantUrl : cta.dataset.controlUrl;
      if (destination) cta.href = destination;
      if (label) cta.setAttribute("aria-label", label);
    });

    const exposureKey = `rush-experiment-exposure:${heroExperiment.id}:${heroExperiment.variant}`;
    let shouldPublishExposure = true;
    try {
      shouldPublishExposure = window.sessionStorage.getItem(exposureKey) !== "true";
      if (shouldPublishExposure) window.sessionStorage.setItem(exposureKey, "true");
    } catch (error) {
      // Session storage is optional; publishing remains safe when unavailable.
    }
    if (shouldPublishExposure) {
      publishRushEvent("hero_experiment_viewed", {
        experiment_id: heroExperiment.id,
        variant: heroExperiment.variant,
        cta_type: "primary",
        destination: heroExperiment.variant === "ready_to_ship" ? heroExperiment.variantUrl : heroExperiment.controlUrl,
      });
    }
  }

  const getProductEventContext = (product) => ({
    product_id: product?.dataset.productId || "",
    product_handle: product?.dataset.productHandle || "",
    currency: product?.dataset.currency || window.Shopify?.currency?.active || "",
  });

  document.addEventListener("click", (event) => {
    const heroCta = event.target.closest("[data-hero-cta]");
    if (!heroCta) return;
    const heroEventData = {
      cta_type: heroCta.dataset.ctaType || "primary",
      destination: heroCta.getAttribute("href") || "",
    };
    if (heroCta.dataset.heroExperiment && heroExperiment?.active) {
      heroEventData.experiment_id = heroExperiment.id;
      heroEventData.variant = heroExperiment.variant;
    }
    publishRushEvent("hero_cta_clicked", heroEventData);
  });

  const menuToggle = document.querySelector("[data-menu-toggle]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  const focusableSelector = "a[href], button:not([disabled]), input:not([disabled]):not([type='hidden']), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])";
  const getFocusableElements = (container) => container
    ? [...container.querySelectorAll(focusableSelector)].filter((element) => !element.closest("[hidden], [inert]") && element.getAttribute("aria-hidden") !== "true")
    : [];
  let closeMobileMenu = () => {};

  if (menuToggle && mobileMenu) {
    closeMobileMenu = ({ restoreFocus = false } = {}) => {
      mobileMenu.classList.remove("is-open");
      mobileMenu.setAttribute("aria-hidden", "true");
      mobileMenu.inert = true;
      menuToggle.setAttribute("aria-expanded", "false");
      menuToggle.setAttribute("aria-label", "Open menu");
      document.documentElement.classList.remove("rush-cart-open");
      mobileMenu.querySelectorAll("[data-mobile-shop-toggle]").forEach((toggle) => {
        toggle.setAttribute("aria-expanded", "false");
        const panel = document.getElementById(toggle.getAttribute("aria-controls"));
        if (panel) panel.hidden = true;
      });
      if (restoreFocus) menuToggle.focus();
    };

    menuToggle.addEventListener("click", () => {
      const isOpen = mobileMenu.classList.contains("is-open");
      if (isOpen) {
        closeMobileMenu({ restoreFocus: true });
        return;
      }
      mobileMenu.classList.add("is-open");
      mobileMenu.setAttribute("aria-hidden", "false");
      mobileMenu.inert = false;
      menuToggle.setAttribute("aria-expanded", "true");
      menuToggle.setAttribute("aria-label", "Close menu");
      document.documentElement.classList.add("rush-cart-open");
      window.requestAnimationFrame(() => getFocusableElements(mobileMenu)[0]?.focus());
    });

    mobileMenu.addEventListener("click", (event) => {
      if (event.target.closest("a[href]")) closeMobileMenu();
    });

    document.addEventListener("keydown", (event) => {
      if (!mobileMenu.classList.contains("is-open")) return;
      if (event.key === "Escape") {
        closeMobileMenu({ restoreFocus: true });
        return;
      }
      if (event.key !== "Tab") return;
      const focusable = getFocusableElements(mobileMenu);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    const desktopNavigationQuery = window.matchMedia("(min-width: 861px)");
    const handleNavigationBreakpoint = (event) => {
      if (event.matches) closeMobileMenu();
    };
    if (desktopNavigationQuery.addEventListener) {
      desktopNavigationQuery.addEventListener("change", handleNavigationBreakpoint);
    } else {
      desktopNavigationQuery.addListener(handleNavigationBreakpoint);
    }
  }


  document.querySelectorAll("[data-scroll-target]").forEach((button) => {
    button.addEventListener("click", () => {
      const target = document.querySelector(button.getAttribute("data-scroll-target"));
      const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
      target?.scrollIntoView({ behavior, block: "start" });
    });
  });

  // ─── Scroll animations ───────────────────────────────────────────────────────

  // Elements to animate — mapped to their variant and stagger behaviour
  const RUSH_SELECTORS = [
    // Hero content fades up immediately
    { selector: ".rush-hero__content",        variant: "",        stagger: false },
    { selector: ".rush-cinch-hero__content",  variant: "",        stagger: false },
    { selector: ".rush-lab-hero__content",    variant: "",        stagger: false },
    { selector: ".rush-about__hero-copy",    variant: "",        stagger: false },

    // Section headers slide up
    { selector: ".rush-section-header",       variant: "",        stagger: false },
    { selector: ".rush-section-header--center", variant: "",      stagger: false },

    // Product cards stagger in
    { selector: ".rush-product-card",         variant: "scale",   stagger: true  },
    { selector: ".rush-article-card",         variant: "scale",   stagger: true  },
    { selector: ".rush-blueprint-card",       variant: "scale",   stagger: true  },
    { selector: ".rush-category-tile",        variant: "scale",   stagger: true  },
    { selector: ".rush-customizer-card",      variant: "scale",   stagger: true  },
    { selector: ".rush-community-logo",       variant: "scale",   stagger: true  },
    { selector: ".rush-feature-panel",        variant: "scale",   stagger: true  },
    { selector: ".rush-shop-category__item",  variant: "scale",   stagger: true  },

    // Trust stats count up — stagger
    { selector: ".rush-trust-stat",           variant: "",        stagger: true  },
    { selector: ".rush-step",                 variant: "",        stagger: true  },
    { selector: ".rush-cinch-proof > div",    variant: "",        stagger: true  },
    { selector: ".rush-about__stat",          variant: "",        stagger: true  },
    { selector: ".rush-about__step",          variant: "",        stagger: true  },
    { selector: ".rush-about__value",         variant: "scale",   stagger: true  },

    // Story split — left/right slide
    { selector: ".rush-story__grid > :first-child",   variant: "left",  stagger: false },
    { selector: ".rush-story__grid > :last-child",    variant: "right", stagger: false },
    { selector: ".rush-about__story-title",   variant: "left",    stagger: false },
    { selector: ".rush-about__story-copy",    variant: "right",   stagger: false },
    { selector: ".rush-about__craft-media",   variant: "left",    stagger: false },
    { selector: ".rush-about__craft-copy",    variant: "right",   stagger: false },

    // Contact grid — left/right slide
    { selector: ".rush-contact__brief",       variant: "left",    stagger: false },
    { selector: ".rush-contact__panel",       variant: "right",   stagger: false },

    // Lab control — left/right
    { selector: ".rush-control__grid > :first-child", variant: "left",  stagger: false },
    { selector: ".rush-control__grid > :last-child",  variant: "right", stagger: false },

    // Newsletter box
    { selector: ".rush-newsletter",           variant: "scale",   stagger: false },

    // Spec cards
    { selector: ".rush-spec-card",            variant: "scale",   stagger: true  },

    // Quick-ship scroller
    { selector: ".rush-product-scroller",     variant: "",        stagger: false },
  ];

  // Reduce motion preference
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const shouldAnimate = !prefersReducedMotion && !navigator.connection?.saveData;

  if (shouldAnimate) {
    // Resolve every animation candidate in one DOM scan, then retain the
    // configured order so variants and stagger timing remain unchanged.
    const revealSelector = RUSH_SELECTORS.map(({ selector }) => selector).join(",");
    const revealCandidates = [...document.querySelectorAll(revealSelector)];
    RUSH_SELECTORS.forEach(({ selector, variant, stagger }) => {
      const elements = revealCandidates.filter((element) => element.matches(selector));
      elements.forEach((el, i) => {
        // Skip elements already inside another reveal (avoid double-animating)
        if (el.closest(".rush-reveal")) return;

        el.classList.add("rush-reveal");
        if (variant) el.classList.add(`rush-reveal--${variant}`);

        if (stagger && i > 0) {
          // Cap stagger at 5 items to avoid long waits
          el.style.transitionDelay = `${Math.min(i, 5) * 80}ms`;
        }
      });
    });

    const revealElements = revealCandidates.filter((element) => element.classList.contains("rush-reveal"));
    if (revealElements.length && "IntersectionObserver" in window) {
      // Single IntersectionObserver for all animated elements.
      const rushObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              rushObserver.unobserve(entry.target); // animate once only
            }
          });
        },
        {
          threshold: 0.12,      // trigger when 12% of element is visible
          rootMargin: "0px 0px -40px 0px", // slight offset so elements don't pop in at the very edge
        }
      );

      revealElements.forEach((element) => rushObserver.observe(element));
    } else {
      revealElements.forEach((element) => element.classList.add("is-visible"));
    }
  }

  // ─── Stat counter animation ──────────────────────────────────────────────────
  // Animates numbers like "10,000+" counting up when they scroll into view

  function rushAnimateCounter(el) {
    const raw = el.textContent.trim();
    // Extract numeric portion and suffix (e.g. "10,000+" → num: 10000, suffix: "+")
    const match = raw.match(/^([0-9,]+\.?[0-9]*)(.*)$/);
    if (!match) return;

    const target = parseFloat(match[1].replace(/,/g, ""));
    const suffix = match[2] || "";
    const isFloat = match[1].includes(".");
    const decimals = isFloat ? (match[1].split(".")[1] || "").length : 0;
    const duration = 1200; // ms
    const start = performance.now();

    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // Ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;

      if (decimals > 0) {
        el.textContent = current.toFixed(decimals) + suffix;
      } else if (target >= 1000) {
        el.textContent = Math.round(current).toLocaleString() + suffix;
      } else {
        el.textContent = Math.round(current) + suffix;
      }

      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  // Only create a counter observer on pages that contain numeric stats.
  const counterTargets = !prefersReducedMotion
    ? [...document.querySelectorAll(".rush-trust-stat span, .rush-cinch-proof dt, .rush-about__stat strong")]
      .filter((element) => /^[0-9]/.test(element.textContent.trim()))
    : [];

  if (counterTargets.length && "IntersectionObserver" in window) {
    const counterObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            rushAnimateCounter(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    counterTargets.forEach((element) => counterObserver.observe(element));
  }
  // ─── Commerce layer ────────────────────────────────────────────────────────

  const cartDrawer = document.querySelector("[data-cart-drawer]");
  const cartLines = cartDrawer?.querySelector("[data-cart-lines]");
  const cartTotal = cartDrawer?.querySelector("[data-cart-total]");
  const cartStatus = cartDrawer?.querySelector("[data-cart-status]");
  const cartPanel = cartDrawer?.querySelector(".rush-cart-drawer__panel");
  const shippingProgress = cartDrawer?.querySelector("[data-shipping-progress]");
  const cartUpsells = cartDrawer?.querySelector("[data-cart-upsells]");
  const cartFooter = cartDrawer?.querySelector("[data-cart-footer]");
  const cartCheckout = cartDrawer?.querySelector("[data-cart-checkout]");
  const cartCheckoutLabel = cartDrawer?.querySelector("[data-cart-checkout-label]");
  let lastFocusedElement = null;
  let latestCart = null;
  let cartOpenEventPending = false;
  let shippingThresholdPublished = false;
  const publishedUpsellImpressions = new Set();

  const escapeHTML = (value = "") =>
    String(value).replace(/[&<>"']/g, (character) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    })[character]);

  const iconMarkup = (icon) => `<svg class="material-symbols-outlined rush-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><use href="#rush-icon-${icon}"></use></svg>`;

  const formatMoney = (cents, currency = "USD") =>
    new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency,
    }).format(Number(cents || 0) / 100);

  document.querySelectorAll("[data-accelerated-checkout]").forEach((checkout) => {
    publishRushEvent("accelerated_checkout_viewed", {
      interface: checkout.dataset.checkoutInterface || "unknown",
      item_count: Number(checkout.dataset.itemCount || 0),
      cart_total_cents: Number(checkout.dataset.cartTotal || 0),
      currency: checkout.dataset.currency || "",
    });
  });

  function setCartStatus(message, isError = false) {
    if (!cartStatus) return;
    cartStatus.textContent = message;
    cartStatus.classList.toggle("is-error", isError);
  }

  function updateCartCount(count) {
    document.querySelectorAll(".rush-cart-link").forEach((link) => {
      let badge = link.querySelector(".rush-cart-count");
      if (!badge && count > 0) {
        badge = document.createElement("span");
        badge.className = "rush-cart-count";
        link.appendChild(badge);
      }
      if (badge) {
        badge.textContent = String(count);
        badge.hidden = count < 1;
      }
      link.setAttribute("aria-label", `Cart, ${count} item${count === 1 ? "" : "s"}`);
    });
  }

  function getCartPlatform(cartItems = []) {
    const platforms = new Set();
    cartItems.forEach((item) => {
      const searchableText = [
        item.product_type,
        item.product_title,
        item.variant_title,
        item.handle,
        item.vendor,
        item.url,
      ].filter(Boolean).join(" ").toLowerCase();

      if (/playstation|\bps\s*5\b|\bps5\b|dualsense/.test(searchableText)) platforms.add("ps5");
      if (/xbox|elite\s*series/.test(searchableText)) platforms.add("xbox");
      if (/nintendo|switch|joy[ -]?con/.test(searchableText)) platforms.add("nintendo");
    });

    return platforms.size === 1 ? [...platforms][0] : "universal";
  }

  function renderContextualCartUpsell(cart, hasItems) {
    if (!cartUpsells) return;

    const cartVariantIds = new Set(cart.items.map((item) => String(item.variant_id)));
    const cartPlatform = getCartPlatform(cart.items);
    const candidates = [...cartUpsells.querySelectorAll("[data-upsell-variant]")];
    const eligibleCandidates = candidates.filter((candidate) => !cartVariantIds.has(candidate.dataset.upsellVariant));
    const priority = cartPlatform === "universal"
      ? ["universal", "fallback"]
      : [cartPlatform, "universal", "fallback"];
    const selected = priority
      .map((context) => eligibleCandidates.find((candidate) => candidate.dataset.upsellContext === context))
      .find(Boolean);

    candidates.forEach((candidate) => {
      candidate.hidden = candidate !== selected;
      delete candidate.dataset.activeCartContext;
    });
    cartUpsells.hidden = !hasItems || !selected;

    if (!hasItems || !selected || !cartDrawer?.classList.contains("is-open")) return;
    selected.dataset.activeCartContext = cartPlatform;
    const impressionKey = `${selected.dataset.upsellVariant}:${cartPlatform}`;
    if (publishedUpsellImpressions.has(impressionKey)) return;

    publishedUpsellImpressions.add(impressionKey);
    publishRushEvent("cart_upsell_viewed", {
      product_id: selected.dataset.upsellProductId || "",
      product_handle: selected.dataset.upsellProductHandle || "",
      variant_id: selected.dataset.upsellVariant || "",
      upsell_context: selected.dataset.upsellContext || "",
      cart_context: cartPlatform,
      item_count: Number(cart.item_count || 0),
      cart_total_cents: Number(cart.total_price || 0),
      currency: cart.currency || "",
    });
  }

  function renderCart(cart) {
    latestCart = cart;
    const hasItems = cart.item_count > 0;
    const formattedTotal = formatMoney(cart.total_price, cart.currency);
    setCartStatus("");
    updateCartCount(cart.item_count);
    if (cartTotal) cartTotal.textContent = formattedTotal;
    if (cartFooter) cartFooter.hidden = !hasItems;
    if (cartCheckoutLabel) cartCheckoutLabel.textContent = `Secure checkout · ${formattedTotal}`;
    if (cartCheckout) cartCheckout.setAttribute("aria-label", `Secure checkout with ${cart.item_count} item${cart.item_count === 1 ? "" : "s"}, subtotal ${formattedTotal}`);
    if (shippingProgress) {
      shippingProgress.hidden = !hasItems;
      const threshold = Number(shippingProgress.dataset.threshold || 0);
      const remaining = Math.max(threshold - cart.total_price, 0);
      const progress = threshold ? Math.min((cart.total_price / threshold) * 100, 100) : 100;
      shippingProgress.querySelector("[data-shipping-bar]").style.width = `${progress}%`;
      shippingProgress.querySelector("[data-shipping-message]").textContent = remaining > 0 ? `${formatMoney(remaining, cart.currency)} away from free shipping` : "You unlocked free shipping";
      if (!remaining && hasItems && !shippingThresholdPublished) {
        publishRushEvent("shipping_threshold_reached", {
          threshold_cents: threshold,
          cart_total_cents: Number(cart.total_price || 0),
          currency: cart.currency,
          item_count: cart.item_count,
        });
        shippingThresholdPublished = true;
      }
    }

    renderContextualCartUpsell(cart, hasItems);
    if (cartOpenEventPending && cartDrawer?.classList.contains("is-open")) {
      publishRushEvent("cart_drawer_opened", {
        item_count: cart.item_count,
        cart_total_cents: Number(cart.total_price || 0),
        currency: cart.currency,
      });
      cartOpenEventPending = false;
    }
    if (!cartLines) return;

    if (!cart.items.length) {
      cartLines.innerHTML = `
        <div class="rush-cart-drawer__empty">
          ${iconMarkup("shopping-bag")}
          <p>Your loadout is empty.</p>
          <a class="rush-button rush-button--ghost" href="${escapeHTML(window.RushTheme.routes.allProducts || "/collections/all")}">Shop controllers</a>
        </div>`;
      return;
    }

    cartLines.innerHTML = cart.items.map((item) => `
      <article class="rush-drawer-line">
        <a href="${escapeHTML(item.url)}" class="rush-drawer-line__image">
          ${item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" width="120" height="120" loading="lazy">` : ""}
        </a>
        <div class="rush-drawer-line__content">
          <a href="${escapeHTML(item.url)}"><strong>${escapeHTML(item.product_title)}</strong></a>
          ${item.variant_title ? `<span>${escapeHTML(item.variant_title)}</span>` : ""}
          ${Object.entries(item.properties || {}).filter(([key, value]) => value && !key.startsWith("_")).map(([key, value]) => `<small>${escapeHTML(key)}: ${escapeHTML(value)}</small>`).join("")}
          <div class="rush-drawer-line__meta">
            <div class="rush-drawer-quantity" aria-label="Quantity">
              <button type="button" data-cart-quantity data-line-key="${escapeHTML(item.key)}" data-quantity="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-quantity data-line-key="${escapeHTML(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" data-cart-remove data-line-key="${escapeHTML(item.key)}">Remove</button>
          </div>
        </div>
        <strong>${formatMoney(item.final_line_price, cart.currency)}</strong>
      </article>`).join("");
  }

  async function getCart() {
    const response = await fetch(window.RushTheme.routes.cartJson, {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("Unable to load cart.");
    return response.json();
  }

  async function refreshCart() {
    const cart = await getCart();
    renderCart(cart);
    return cart;
  }

  function openCart({ refresh = true } = {}) {
    if (!cartDrawer) return;
    closeMobileMenu();
    const wasOpen = cartDrawer.classList.contains("is-open");
    lastFocusedElement = document.activeElement;
    cartDrawer.classList.add("is-open");
    cartDrawer.setAttribute("aria-hidden", "false");
    cartDrawer.inert = false;
    document.querySelectorAll(".rush-cart-link").forEach((link) => link.setAttribute("aria-expanded", "true"));
    document.documentElement.classList.add("rush-cart-open");
    cartPanel?.focus();
    if (latestCart) renderContextualCartUpsell(latestCart, latestCart.item_count > 0);
    if (!wasOpen) {
      cartOpenEventPending = true;
      if (!refresh && latestCart) {
        publishRushEvent("cart_drawer_opened", {
          item_count: latestCart.item_count,
          cart_total_cents: Number(latestCart.total_price || 0),
          currency: latestCart.currency,
        });
        cartOpenEventPending = false;
      }
    }
    if (refresh) refreshCart().catch(() => setCartStatus(window.RushTheme.strings.error, true));
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("is-open");
    cartDrawer.setAttribute("aria-hidden", "true");
    cartDrawer.inert = true;
    document.querySelectorAll(".rush-cart-link").forEach((link) => link.setAttribute("aria-expanded", "false"));
    document.documentElement.classList.remove("rush-cart-open");
    lastFocusedElement?.focus();
  }

  async function addItems(items) {
    const response = await fetch(window.RushTheme.routes.cartAddJson, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    });
    const result = await response.json();
    if (!response.ok) {
      const requestError = new Error(result.description || result.message || window.RushTheme.strings.error);
      requestError.status = response.status;
      throw requestError;
    }
    await refreshCart();
    setCartStatus(window.RushTheme.strings.added);
    openCart({ refresh: false });
    return result;
  }

  window.RushTheme.cart = {
    addItems,
    open: openCart,
    setStatus: setCartStatus,
  };

  async function changeCartItem(key, quantity) {
    const response = await fetch(window.RushTheme.routes.cartChangeJson, {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(Number(quantity), 0) }),
    });
    let result = null;
    try {
      result = await response.json();
    } catch (error) {
      // Shopify can occasionally return an empty or non-JSON error response.
    }
    if (!response.ok) {
      const requestError = new Error(result?.description || result?.message || window.RushTheme.strings.error);
      requestError.status = response.status;
      throw requestError;
    }
    renderCart(result);
    return result;
  }

  // Keep cart mutations in customer click order so slower responses cannot
  // restore an older quantity after a newer selection.
  let cartChangeQueue = Promise.resolve();
  let pendingCartChanges = 0;
  const pendingAddForms = new WeakSet();
  function queueCartItemChange(key, quantity) {
    const operation = cartChangeQueue.then(() => changeCartItem(key, quantity));
    cartChangeQueue = operation.catch(() => {});
    return operation;
  }

  document.addEventListener("submit", async (event) => {
    const form = event.target.closest("form[data-ajax-cart]");
    if (!form) return;
    if (event.submitter?.name === "checkout" || event.submitter?.closest(".shopify-payment-button")) return;
    event.preventDefault();
    if (pendingAddForms.has(form)) return;

    const submitButton = event.submitter || form.querySelector("[type='submit']");
    const formData = new FormData(form);
    const id = Number(formData.get("id"));
    const quantity = Number(formData.get("quantity") || 1);
    if (!id) return;

    const product = form.closest(".rush-product");
    const upsell = form.closest("[data-upsell-variant]");
    const isCartUpsell = form.classList.contains("rush-cart-upsell__form");
    const itemPrice = Number(form.dataset.productPrice || 0);
    const addEventData = {
      ...getProductEventContext(product),
      product_id: String(form.dataset.productId || product?.dataset.productId || ""),
      product_handle: form.dataset.productHandle || product?.dataset.productHandle || "",
      variant_id: String(id),
      quantity,
      item_price_cents: itemPrice,
      value_cents: itemPrice * quantity,
      currency: form.dataset.currency || product?.dataset.currency || window.Shopify?.currency?.active || "",
      source: form.dataset.addSource || "unknown",
      interface: isCartUpsell ? "cart_upsell" : event.submitter?.matches("[data-sticky-add]") ? "mobile_sticky" : "primary",
      ...(isCartUpsell ? {
        upsell_context: upsell?.dataset.upsellContext || "",
        cart_context: upsell?.dataset.activeCartContext || "",
      } : {}),
    };

    pendingAddForms.add(form);
    submitButton?.setAttribute("aria-busy", "true");
    if (submitButton) submitButton.disabled = true;
    if (isCartUpsell) publishRushEvent("cart_upsell_clicked", addEventData);

    try {
      await addItems([{ id, quantity }]);
      publishRushEvent("add_to_cart", addEventData);
      if (isCartUpsell) {
        publishRushEvent("cart_upsell_added", addEventData);
      }
    } catch (error) {
      publishRushEvent(error.status === 422 ? "cart_inventory_error" : "cart_error", {
        operation: "add",
        status: Number(error.status || 0),
        variant_id: String(id),
        quantity,
      });
      openCart({ refresh: false });
      try { await refreshCart(); } catch (refreshError) { /* Preserve the actionable add error. */ }
      setCartStatus(error.message, true);
    } finally {
      pendingAddForms.delete(form);
      submitButton?.removeAttribute("aria-busy");
      if (submitButton) submitButton.disabled = false;
    }
  });

  document.addEventListener("click", async (event) => {
    const cartLink = event.target.closest(".rush-cart-link");
    const checkoutButton = event.target.closest("[data-cart-checkout], [data-cart-page-checkout]");
    const acceleratedControl = event.target.closest("shopify-accelerated-checkout-cart, shopify-accelerated-checkout, .additional-checkout-button, button, a");
    const acceleratedCheckout = acceleratedControl?.closest("[data-accelerated-checkout]");
    const restockButton = event.target.closest("[data-sticky-notify]");
    const closeButton = event.target.closest("[data-cart-close]");
    const removeButton = event.target.closest("[data-cart-remove]");
    const quantityButton = event.target.closest("[data-cart-quantity]");

    if (checkoutButton) {
      const checkoutEventData = {
        item_count: Number(latestCart?.item_count || checkoutButton.dataset.itemCount || 0),
        cart_total_cents: Number(latestCart?.total_price || checkoutButton.dataset.cartTotal || 0),
        currency: latestCart?.currency || checkoutButton.dataset.currency || "",
        interface: checkoutButton.dataset.checkoutInterface || "unknown",
        checkout_type: checkoutButton.dataset.checkoutType || "standard",
      };
      publishRushEvent("checkout_cta_clicked", checkoutEventData);
      publishRushEvent("checkout_started", checkoutEventData);
    }
    if (acceleratedCheckout) {
      publishRushEvent("accelerated_checkout_clicked", {
        interface: acceleratedCheckout.dataset.checkoutInterface || "unknown",
        item_count: Number(acceleratedCheckout.dataset.itemCount || 0),
        cart_total_cents: Number(acceleratedCheckout.dataset.cartTotal || 0),
        currency: acceleratedCheckout.dataset.currency || "",
      });
    }
    if (restockButton) {
      const product = restockButton.closest(".rush-product");
      publishRushEvent("restock_cta_clicked", {
        ...getProductEventContext(product),
        variant_id: String(product?.querySelector("[name='id']")?.value || ""),
      });
    }
    if (cartLink && cartDrawer) {
      event.preventDefault();
      openCart();
      return;
    }
    if (closeButton) {
      closeCart();
      return;
    }
    const changeButton = removeButton || quantityButton;
    if (!changeButton) return;

    cartLines?.querySelectorAll("[data-cart-quantity], [data-cart-remove]").forEach((button) => { button.disabled = true; });
    pendingCartChanges += 1;
    cartLines?.setAttribute("aria-busy", "true");
    try {
      await queueCartItemChange(changeButton.dataset.lineKey, removeButton ? 0 : changeButton.dataset.quantity);
      setCartStatus(removeButton ? "Item removed." : "Quantity updated.");
    } catch (error) {
      publishRushEvent(error.status === 422 ? "cart_inventory_error" : "cart_error", {
        operation: removeButton ? "remove" : "quantity_change",
        status: Number(error.status || 0),
        requested_quantity: Number(removeButton ? 0 : changeButton.dataset.quantity),
      });
      try { await refreshCart(); } catch (refreshError) { /* Keep the current cart visible if refresh fails. */ }
      setCartStatus(error.message, true);
      cartLines?.querySelectorAll("[data-cart-quantity], [data-cart-remove]").forEach((button) => { button.disabled = false; });
    } finally {
      pendingCartChanges -= 1;
      if (!pendingCartChanges) cartLines?.removeAttribute("aria-busy");
    }
  });

  document.querySelectorAll(".rush-restock-alert").forEach((form) => {
    form.addEventListener("submit", () => {
      const product = form.closest(".rush-product");
      publishRushEvent("restock_request_submitted", {
        ...getProductEventContext(product),
        variant_id: String(product?.querySelector("[name='id']")?.value || ""),
      });
    });
  });

  document.querySelector("[data-discount-form]")?.addEventListener("submit", (event) => {
    event.preventDefault();
    const code = new FormData(event.currentTarget).get("discount")?.trim();
    if (code) {
      const checkoutEventData = {
        item_count: Number(latestCart?.item_count || 0),
        cart_total_cents: Number(latestCart?.total_price || 0),
        currency: latestCart?.currency || "",
        interface: "cart_drawer_discount",
        checkout_type: "standard",
      };
      publishRushEvent("checkout_cta_clicked", checkoutEventData);
      publishRushEvent("checkout_started", checkoutEventData);
      window.location.href = `${window.RushTheme.routes.discount}${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.RushTheme.routes.checkout)}`;
    }
  });

  document.addEventListener("keydown", (event) => {
    if (!cartDrawer?.classList.contains("is-open")) return;
    if (event.key === "Escape") {
      closeCart();
      return;
    }
    if (event.key !== "Tab") return;

    const focusable = getFocusableElements(cartPanel);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });



  // Shopify-generated product recommendations. Load only as the section nears
  // the viewport so it does not compete with product media and add-to-cart UI.
  async function loadRecommendations(container) {
    if (container.children.length || !container.dataset.url) return;
    try {
      const response = await fetch(container.dataset.url);
      if (!response.ok) return;
      const documentFragment = new DOMParser().parseFromString(await response.text(), "text/html");
      const recommendations = documentFragment.querySelector("[data-product-recommendations]");
      if (recommendations?.innerHTML.trim()) {
        container.innerHTML = recommendations.innerHTML;
        renderWishlist();
      }
    } catch (error) {
      // Recommendations are progressive enhancement.
    }
  }

  const recommendationSections = [...document.querySelectorAll("[data-product-recommendations]")];
  if (recommendationSections.length && "IntersectionObserver" in window) {
    const recommendationObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        recommendationObserver.unobserve(entry.target);
        loadRecommendations(entry.target);
      });
    }, { rootMargin: "400px 0px" });
    recommendationSections.forEach((section) => recommendationObserver.observe(section));
  } else {
    recommendationSections.forEach(loadRecommendations);
  }

  // Recently viewed products remain local to the visitor's browser.
  document.querySelectorAll("[data-recently-viewed]").forEach((section) => {
    const key = "rush-recently-viewed";
    let viewed = [];
    try { viewed = JSON.parse(localStorage.getItem(key) || "[]"); } catch (error) { viewed = []; }
    const current = {
      handle: section.dataset.currentProduct,
      title: section.dataset.productTitle,
      url: section.dataset.productUrl,
      image: section.dataset.productImage,
      price: section.dataset.productPrice,
    };
    const prior = viewed.filter((item) => item.handle && item.handle !== current.handle).slice(0, 4);
    const grid = section.querySelector("[data-recently-viewed-grid]");
    if (grid && prior.length) {
      grid.innerHTML = prior.map((item) => `<a class="rush-recent-card" href="${escapeHTML(item.url)}"><span>${item.image ? `<img src="${escapeHTML(item.image)}" alt="" width="320" height="320" loading="lazy">` : ""}</span><strong>${escapeHTML(item.title)}</strong><small>${escapeHTML(item.price)}</small></a>`).join("");
    } else {
      section.hidden = true;
    }
    try { localStorage.setItem(key, JSON.stringify([current, ...prior].slice(0, 5))); } catch (error) { /* Storage can be unavailable. */ }
  });

  // Lightweight local wishlist.
  const wishlistDrawer = document.querySelector("[data-wishlist-drawer]");
  const wishlistPanel = wishlistDrawer?.querySelector("[role='dialog']");
  const wishlistItems = wishlistDrawer?.querySelector("[data-wishlist-items]");
  const wishlistKey = "rush-wishlist";
  let wishlistLastFocused = null;
  const readWishlist = () => {
    try { return JSON.parse(localStorage.getItem(wishlistKey) || "[]"); } catch (error) { return []; }
  };
  const writeWishlist = (items) => {
    try { localStorage.setItem(wishlistKey, JSON.stringify(items)); } catch (error) { /* Storage can be unavailable. */ }
  };
  function renderWishlist() {
    const items = readWishlist();
    document.querySelectorAll("[data-wishlist-count]").forEach((count) => { count.textContent = String(items.length); count.hidden = !items.length; });
    document.querySelectorAll("[data-wishlist-toggle]").forEach((button) => {
      const saved = items.some((item) => item.handle === button.dataset.productHandle);
      button.setAttribute("aria-pressed", String(saved));
      button.setAttribute("aria-label", `${saved ? "Remove" : "Save"} ${button.dataset.productTitle || "product"} ${saved ? "from" : "to"} wishlist`);
      button.classList.toggle("is-saved", saved);
    });
    if (wishlistItems) wishlistItems.innerHTML = items.length ? items.map((item) => `<article class="rush-wishlist-item">${item.image ? `<img src="${escapeHTML(item.image)}" alt="" width="90" height="90">` : ""}<a href="${escapeHTML(item.url)}"><strong>${escapeHTML(item.title)}</strong><span>View product</span></a><button type="button" data-wishlist-remove="${escapeHTML(item.handle)}" aria-label="Remove ${escapeHTML(item.title)}">${iconMarkup("close")}</button></article>`).join("") : `<div class="rush-cart-drawer__empty">${iconMarkup("favorite")}<p>No saved builds yet.</p></div>`;
  }
  document.addEventListener("click", (event) => {
    const toggle = event.target.closest("[data-wishlist-toggle]");
    const remove = event.target.closest("[data-wishlist-remove]");
    if (toggle) {
      const items = readWishlist();
      const handle = toggle.dataset.productHandle;
      const existing = items.findIndex((item) => item.handle === handle);
      if (existing >= 0) items.splice(existing, 1);
      else items.unshift({ handle, title: toggle.dataset.productTitle, url: toggle.dataset.productUrl, image: toggle.dataset.productImage });
      writeWishlist(items.slice(0, 30));
      renderWishlist();
    }
    if (remove) {
      writeWishlist(readWishlist().filter((item) => item.handle !== remove.dataset.wishlistRemove));
      renderWishlist();
    }
    const wishlistOpenButton = event.target.closest("[data-wishlist-open]");
    if (wishlistOpenButton) {
      closeMobileMenu();
      wishlistLastFocused = wishlistOpenButton;
      wishlistOpenButton.setAttribute("aria-expanded", "true");
      wishlistDrawer?.classList.add("is-open");
      wishlistDrawer?.setAttribute("aria-hidden", "false");
      if (wishlistDrawer) wishlistDrawer.inert = false;
      document.documentElement.classList.add("rush-cart-open");
      window.requestAnimationFrame(() => wishlistPanel?.focus());
    }
    if (event.target.closest("[data-wishlist-close]")) {
      wishlistDrawer?.classList.remove("is-open");
      wishlistDrawer?.setAttribute("aria-hidden", "true");
      if (wishlistDrawer) wishlistDrawer.inert = true;
      document.querySelectorAll("[data-wishlist-open]").forEach((button) => button.setAttribute("aria-expanded", "false"));
      document.documentElement.classList.remove("rush-cart-open");
      wishlistLastFocused?.focus();
    }
  });
  renderWishlist();

  // Predictive product search.
  const searchOverlay = document.querySelector("[data-search-overlay]");
  const searchInput = searchOverlay?.querySelector("[data-predictive-search-input]");
  const searchResults = searchOverlay?.querySelector("[data-predictive-results]");
  let searchTimer;
  let searchFocusTimer;
  let searchController;
  let searchRequestId = 0;
  let searchLastFocused = null;
  document.addEventListener("click", (event) => {
    const searchOpenButton = event.target.closest("[data-search-open]");
    if (searchOpenButton) {
      closeMobileMenu();
      searchLastFocused = searchOpenButton;
      searchOpenButton.setAttribute("aria-expanded", "true");
      searchOverlay?.classList.add("is-open");
      searchOverlay?.setAttribute("aria-hidden", "false");
      if (searchOverlay) searchOverlay.inert = false;
      document.documentElement.classList.add("rush-cart-open");
      searchFocusTimer = window.setTimeout(() => searchInput?.focus(), 50);
    }
    if (event.target.closest("[data-search-close]")) {
      clearTimeout(searchTimer);
      clearTimeout(searchFocusTimer);
      searchController?.abort();
      searchOverlay?.classList.remove("is-open");
      searchOverlay?.setAttribute("aria-hidden", "true");
      if (searchOverlay) searchOverlay.inert = true;
      searchInput?.setAttribute("aria-expanded", "false");
      document.querySelectorAll("[data-search-open]").forEach((button) => button.setAttribute("aria-expanded", "false"));
      document.documentElement.classList.remove("rush-cart-open");
      searchLastFocused?.focus();
    }
  });
  searchInput?.addEventListener("input", () => {
    clearTimeout(searchTimer);
    searchController?.abort();
    const requestId = ++searchRequestId;
    const query = searchInput.value.trim();
    searchInput.setAttribute("aria-expanded", String(query.length > 1));
    if (query.length < 2) {
      searchResults.innerHTML = "";
      searchResults.removeAttribute("aria-busy");
      return;
    }
    searchTimer = window.setTimeout(async () => {
      searchController = new AbortController();
      searchResults.setAttribute("aria-busy", "true");
      try {
        const url = `${window.RushTheme.routes.predictiveSearch}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(url, {
          headers: { Accept: "application/json" },
          signal: searchController.signal,
        });
        if (!response.ok) throw new Error("Search request failed.");
        const products = (await response.json()).resources?.results?.products || [];
        if (requestId !== searchRequestId || searchInput.value.trim() !== query) return;
        searchResults.innerHTML = products.length ? products.map((product) => `<a href="${escapeHTML(product.url)}">${product.image ? `<img src="${escapeHTML(product.image)}" alt="" width="72" height="72">` : ""}<span><strong>${escapeHTML(product.title)}</strong><small>${escapeHTML(product.price)}</small></span>${iconMarkup("arrow-forward")}</a>`).join("") : `<p>No products found for “${escapeHTML(query)}”.</p>`;
      } catch (error) {
        if (error.name !== "AbortError" && requestId === searchRequestId) {
          searchResults.innerHTML = "<p>Search is temporarily unavailable.</p>";
        }
      } finally {
        if (requestId === searchRequestId) searchResults.removeAttribute("aria-busy");
      }
    }, 180);
  });

  document.addEventListener("keydown", (event) => {
    const activeDialog = searchOverlay?.classList.contains("is-open") ? searchOverlay.querySelector("[role='dialog']") : wishlistDrawer?.classList.contains("is-open") ? wishlistDrawer.querySelector("[role='dialog']") : null;
    if (!activeDialog) return;
    if (event.key === "Escape") {
      activeDialog.closest("[data-search-overlay]")?.querySelector("[data-search-close]")?.click();
      activeDialog.closest("[data-wishlist-drawer]")?.querySelector("[data-wishlist-close]")?.click();
      return;
    }
    if (event.key !== "Tab") return;
    const focusable = getFocusableElements(activeDialog);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  // Region-aware consent through Shopify's Customer Privacy API.
  const cookieBanner = document.querySelector("[data-cookie-banner]");
  if (cookieBanner && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
      if (!error && window.Shopify.customerPrivacy?.shouldShowBanner()) cookieBanner.hidden = false;
    });
    cookieBanner.querySelector("[data-cookie-accept]")?.addEventListener("click", () => window.Shopify.customerPrivacy.setTrackingConsent(true, () => { cookieBanner.hidden = true; }));
    cookieBanner.querySelector("[data-cookie-decline]")?.addEventListener("click", () => window.Shopify.customerPrivacy.setTrackingConsent(false, () => { cookieBanner.hidden = true; }));
  }
})();
